import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withNamespaces } from 'react-i18next';
import loader from '../../Comman/images/loader.gif'
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

var svValidator;
var engValidator;
var currentLang;

class AlarmFieldsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            freeCustomText: '',
            dropdownValue: '',
            RegionId:''
        }

        this.toggleChange = this.toggleChange.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleChange = this.handleChange.bind(this);

        if (sessionStorage.getItem('Language')) {
            currentLang = sessionStorage.getItem('Language');
        }
        else {
            currentLang = "en";
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.getAllAlarmStatusData.message != this.props.getAllAlarmStatusData.message) {
            if (nextProps.getAllAlarmStatusData.statusCode == 200) {
                swal(nextProps.getAllAlarmStatusData.message, {
                    icon: "success",
                });
                // this.props.getSMTPdata();
            }
        }
        this.translateLang();
    }
    translateLang() {
        var language;
        if (sessionStorage.getItem('Language')) {
            language = sessionStorage.getItem('Language');
        }
        else {
            language = "en";
        }
        if (language == "en") {
            this.validator = engValidator;
        }
        else {
            this.validator = svValidator;
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.getAllAlarmStatusData != this.props.getAllAlarmStatusData) {
            this.props.getAllAlarmStatusData.alarmDataList.forEach(item => {
                if (item.FieldName == 'Description' && item.IsEnable == false) {
                    if (item.FreeTextDescriptionId == 0) {
                        this.setState({
                            dropdownValue : 'Free-Text',
                            freeCustomText: item.CustomDescription
                        })
                    }
                    else if(item.FreeTextDescriptionId == -1){
                        this.setState({
                            dropdownValue : 'None',
                            freeCustomText: ''
                        })
                    }
                    else if(item.FreeTextDescriptionId > 0){
                        this.setState({
                            dropdownValue : item.FreeTextDescriptionId,
                            freeCustomText: ''
                        })
                    }
                }
            })
        }
    }
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required: 'The :attribute field is required.',
            min: 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required: 'Fältet :attribute krävs.',
            min: ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale: 'en'
            }
        );
        svValidator = new SimpleReactValidator(
            {
                locale: 'sv'
            }
        );
        this.validator = engValidator;
    }

    toggleChange(e, position, data) {
        this.setState({
            [e.target.name]: e.target.value
        })
        this.props.getAllAlarmStatusData.alarmDataList.map((item, index) => {
            if (index === position) {
                item.IsEnable = !item.IsEnable
            }
        })
        // new Array(this.props.getAllAlarmStatusData.alarmDataList.length).fill(false);
        let payload =
        {
            "FieldName": data.FieldName,
            // "CustomDescription": "",
            "IsEnable": data.IsEnable,
            "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
        }
        this.props.updateAlarmField(payload);
    }
    handleInput = (e) => {
        let value = e.target.value;
        let name = e.target.name;

        this.setState({ [name]: value })
    }
    handleChange = (e) => {
        this.setState({
            dropdownValue: e.target.value
        })
        if (e.target.value == 'None') {
            let payload = {
                "FreeTextDescriptionId": -1,
                "FieldName": 'Description',
                "CustomDescription": '',
                "IsEnable": false,
                 "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            }
            this.props.updateAlarmField(payload);
        }
        this.props.getAllAlarmStatusData.predefinedTextList.forEach(item => {
            if (item.ID == e.target.value) {
                let payload = {
                    "FreeTextDescriptionId": e.target.value,
                    "FieldName": 'Description',
                    "CustomDescription": item.Description,
                    "IsEnable": false,
                       "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
                }
                this.props.updateAlarmField(payload);
            }
        })

    }
    saveTextFree() {
        if (this.state.dropdownValue == 'Free-Text' && this.state.freeCustomText.length > 0) {
            let payload = {
                "FreeTextDescriptionId": 0,
                "FieldName": 'Description',
                "CustomDescription": this.state.freeCustomText,
                "IsEnable": false,
                   "RegionId": this.state.RegionId == '' ? (this.props.getAllAlarmStatusData.regionList.length > 0 ? this.props.getAllAlarmStatusData.regionList[0].ID : null) : this.state.RegionId,
            }
            this.props.updateAlarmField(payload);
        }
    }
     changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    render() {
        const { t } = this.props;
          let  regionListOption;
      let regionList=this.props.getAllAlarmStatusData.regionList;
      if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Alarm Setting.Show and hide alarm fields')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                               <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div><br></br>
                            <div className=" panel-body-inputin" style={{marginTop:'40px'}}>
                                <form>
                                    {
                                        (this.props.getAllAlarmStatusData && this.props.getAllAlarmStatusData.alarmDataList.length >0) ?
                                            this.props.getAllAlarmStatusData.alarmDataList.map((item, index) =>
                                                <div className="form-group">
                                                    <div className="row">
                                                        <div className='col-md-3'></div>
                                                        <div className="col-md-3 radio-label">
                                                            <label htmlFor={item.FieldName} className="form-label">{item.FieldName}</label>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label class="send-profile-switch">
                                                                <input
                                                                    id={item.FieldName + index}
                                                                    name={item.FieldName + index}
                                                                    onChange={(event) => this.toggleChange(event, index, item)}
                                                                    checked={item.IsEnable}
                                                                    value={item.IsEnable}
                                                                    type="checkbox" />
                                                                <span class="send-profile-slider-round"></span>
                                                            </label>
                                                            {
                                                                (item.FieldName == 'Description' && item.IsEnable == false) ?
                                                                    <div>
                                                                        <select name="custom-text-options" value={this.state.dropdownValue}
                                                                            onChange={this.handleChange} className='predefined-text-list'>
                                                                            <option value='' selected disabled>Select Option</option>
                                                                            <option value='None'>None</option>
                                                                            <option value='Free-Text'>Free Text</option>
                                                                            {this.props.getAllAlarmStatusData.predefinedTextList.map((e, key) => {
                                                                                return (
                                                                                    <option key={key} value={e.ID}>{e.Description}</option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                    : ''
                                                            }
                                                            <br></br>
                                                             {
                                                                (this.state.dropdownValue == 'Free-Text' && item.FieldName == 'Description' && item.IsEnable == false) ?
                                                                    <div>
                                                                        <textarea
                                                                            rows="8" cols="10" name='freeCustomText'
                                                                            value={this.state.freeCustomText}
                                                                            onChange={this.handleInput}>
                                                                        </textarea>
                                                                        <button style={{ float: 'right' }} type='button' className="btn btn-primary general-btn"
                                                                            onClick={() => { this.saveTextFree() }}>{t('First_Responder.Save')}</button>

                                                                    </div>
                                                                    : ''
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                            : 'No Alarm Fields'
                                    }

                                    {/* <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p className='butn-center'>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={() => { this.save() }}
                                                    disabled={this.props.getAllAlarmStatusData.isLoading == true}
                                                >
                                                    {t('First_Responder.Save')}
                                                </button>
                                                {
                                                    this.props.getAllAlarmStatusData.isLoading ?
                                                        <img src={loader} width="30" alt="" /> : ''
                                                }
                                            </p>
                                        </div>
                                    </div> */}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withNamespaces()(withRouter(AlarmFieldsComponent));
